import { SvgPath } from './lib/dom';
import { ADD_USER, STAR } from './app/const/svg';
var white = '#fff';
export var addUser = new SvgPath({ path: ADD_USER, viewBox: '0 0 328 328', width: 25, height: 25, fill: white });
export var star = new SvgPath({ path: STAR, viewBox: '0 0 24 24', width: 24, height: 24, fill: white });
